import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=29486706&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29486706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29486706')) {
      api.createRecord('29486706', component.options)
    } else {
      api.reload('29486706', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=29486706&scoped=true", function () {
      api.rerender('29486706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/contractKPIManagement/components/ImportExcel/Detail.vue"
export default component.exports